/* Auto-generated from inline schema 2025-08-29T08:39:05.743Z */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'string',
        enum: ['xna'],
      },
    },
  },
  required: ['value'],
}

export const answerSchema = valueSchema
